import { render, staticRenderFns } from "./TabButtonGroup.vue?vue&type=template&id=46bb44b6&scoped=true&"
import script from "./TabButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./TabButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TabButtonGroup.vue?vue&type=style&index=0&id=46bb44b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb44b6",
  null
  
)

export default component.exports